import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';

export async function beforeEnterRequestBookingOverview(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const isActive = await useFeatureFlagStore().requestBookingOverview.isReady();

    if (!isActive) {
        return {name: 'DayBookingOverview', params: to.params, query: to.query};
    }
}
